"use client";

import { useEffect, useState, type FC, type ReactNode } from "react";
import dynamic from "next/dynamic";
import { useTheme } from "next-themes";

interface SquareFrameProps {
  className?: string;
  children?: ReactNode;
}

export const SquareFrameVercel: FC<SquareFrameProps> = ({
  className = "w-full h-full",
  children,
}) => {

  const renderCells = (N: number) =>
    Array.from({ length: N * N }).map((_, idx) => {
      const row = Math.floor(idx / N);
      const isBorder = row === 0;

      return (
        <div
          key={`${N}-${idx}`}
          className={
            isBorder
              ? "border-t border-l border-r border-b-2 border-[#EAEAEA] dark:border-[#1E1E1E]"
              : ""
          }
        />
      );
    });

  return (
    <div className={`relative overflow-visible ${className}`}>
      <div className="absolute inset-0 grid grid-cols-8 grid-rows-8 sm:hidden pointer-events-none">
        {renderCells(8)}
      </div>

      <div className="absolute inset-0 hidden sm:grid md:hidden grid-cols-8 grid-rows-8 pointer-events-none">
        {renderCells(8)}
      </div>

      <div className="absolute inset-0 hidden md:grid lg:hidden grid-cols-12 grid-rows-12 pointer-events-none">
        {renderCells(12)}
      </div>

      <div className="absolute inset-0 hidden lg:grid grid-cols-12 grid-rows-12 pointer-events-none">
        {renderCells(12)}
      </div>
      {children && (
        <div className="relative w-full h-full flex flex-col overflow-visible">
          <div className="pb-5">{children}</div>
        </div>
      )}
    </div>
  );
};
